export default {
	Slide: 'Пазл',
	Puzzle: 'Пазл',
	'The puzzle is open!': 'Пазл відкрито!',
	'Congratulations!': 'Вітаю!',
	'You get it': 'Ти отримуєш',
	'You get the task done': 'Завдання виконано ти отримуєш',

	'Show all blocked': 'Показати всіх заблокованих',

	Author: 'Автор',
	'Reset filters': 'Скинути фільтри',

	Blocked: 'Відновили',
	Unlocked: 'Розблокували',

	Change: 'Змінити',
	'The student is blocked': 'Учня заблоковано',

	'The student is blocked with a new price': 'Учня заблоковано з новим тарифом',
	'To unlock this student, go to the "Restore" section':
		'Щоб розблокувати цього учня зайдіть в розділ “Відновлення”',

	'Before blocking, you can change the price for the student':
		'Перед блокуванням ви можете змінити тариф для учня',

	'Block student': 'Заблокувати учня',

	'First month cost': 'Ціна на 1 місяць',

	'WARNING! After re-saving the task, the students who completed this task will have the puzzle closed and will have to do it again.':
		'Увага! Після повторного збереження завдання, у учнів, які виконали це завдання закриється пазл і треба буде знову його виконувати.',

	"You cannot do homework in the student's platform":
		'Не можна виконувати домашнє завдання в учнівській платформі',

	'Restore the student ?': 'Відновити учня ?',
	'Restore the teacher ?': 'Відновити вчителя ?',
	'Restore the franchise ?': 'Відновити франчазі ?',

	'Transition to 50': 'Перехід через 50',
	'Transition to 100': 'Перехід через 100',

	fifty: 'Перехід через 50',
	hundred: 'Перехід через 100',

	Faces: 'Обличчя',

	Heroes: 'Герої',
	Clothes: 'Одяг',
	Backgrounds: 'Фони',
	Souvenirs: 'Сувеніри',

	'Coming soon': 'Незабаром',

	'Wow! Congratulations, you have successfully purchased this product.':
		'Вау! Вітаю, ти успішно придбав цей товар.',
	'You can view all your purchases in the "Purchased" section':
		'Усі свої покупки ти можеш переглянути в розділі “Придбані"',

	'Your savings': 'Твої накопичення',
	'You can spend them on something interesting!':
		'Ти можеш їх витратити на щось цікаве!',

	'A student with this email address already exists':
		'Користувач із такою електронною адресою вже існує',

	'User with such email already exists':
		'Користувач із такою електронною адресою вже існує',
	'Year of birth': 'Рік народження',
	Registration: 'Реєстрація',
	'Surname of parents': 'Прізвище батьків',
	School: 'Школа',
	'Field is required': 'Поле обов’язкове',
	'Select age': 'Виберіть вік',
	'No such teacher for this year': 'Цього року такого вчителя немає',
	'User with such phone number already exists':
		'Користувач із таким номером телефону вже існує',
	'You are successfully registered': 'Ви успішно зареєстровані',
	'Max length 20 chars': 'Максимальна довжина 20 символів',

	'INTERNATIONAL SCHOOL': 'МІЖНАРОДНА ШКОЛА',
	'Mental Arithmetic': 'Ментальна арифметика',
	'For children aged 5-14.': 'Для дітей 5-14 років.',
	'Sign up for a trial lesson': 'Запишіться на пробне заняття',
	'Parents name': "Ім'я батьків",
	'Childs age': 'Вік дитини',
	Country: 'Країна',
	'Sign up': 'Записатися',
	'Open offer agreement': 'Договір відкритої оферти',
	'Participate in online Indigo Olympiad': 'Змагайся в онлайн олімпіаді Indigo',
	Participate: 'Взяти участь',
	export: 'Експорт',
	wrong: 'Невірно',
	right: 'Вірно',
	match: {
		addition: 'Форсаж',
		multiply: 'Множення',
		divide: 'Ділення',
		abacus_random: 'Абакус рандом',
		anzan: 'Анзан',
		negative: "Від'ємні числа",
		column: 'Стовпці',
	},
	timeIsOver: 'Час вийшов',
	timer: 'Таймер',
	'Back to Lessons': 'Назад до списку уроків',
	'Create Lesson': 'Створити урок',
	Home: 'На головну',
	Assign: 'Призначити',
	'To cabinet': 'У кабiнет',
	'Create a homework': 'Створити домашнє завдання',
	January: 'Січень',
	February: 'Лютий',
	March: 'Березень',
	April: 'Квітень',
	May: 'Травень',
	June: 'Червень',
	July: 'Липень',
	August: 'Серпень',
	'Group nickname': 'Нік групи',
	September: 'Вересень',
	October: 'Жовтень',
	November: 'Листопад',
	December: 'Грудень',
	Overall: 'Загалом',
	Active: 'Активниx',
	'Contract number': 'Номер контракту',
	'For parents': 'Для батьків',
	'Choose lessons': 'Oберіть уроки',
	Save: 'Призначити',
	Close: 'Закрити',
	'Change birthday': 'Зміна дня народження',
	Sent: 'Надіслано',
	'Include students': 'Включити студентів',
	'Add service': 'Додати послугу',
	'Create folder': 'Створити папку',
	Answer: 'Вiдповiдь',
	Price: 'Тариф',
	'Date of creating': 'Дата створення',
	Month: 'Місяць',
	unpaid: 'Не оплачено',
	paid: 'Оплачено',
	'Excluded students': 'Виключені студенти',
	'Selected groups': 'Вибрані групи',
	Monday: 'Понедiлок',
	Tuesday: 'Вiвторок',
	Wensday: 'Середа',
	Thusday: 'Четвер',
	Friday: 'П`ятниця',
	Saturday: 'Субота',
	Sunday: 'Недiля',
	Mo: 'Пн',
	Tu: 'Вт',
	We: 'Ср',
	Th: 'Чт',
	Fr: 'Пт',
	Sa: 'Сб',
	Su: 'Нд',
	End: 'Кінець',
	'Add discount': 'Додати знижку',
	Edit: 'Редагувати',
	'Parent found': 'Батько знайдений',
	'Changes saved': 'Збережено',
	'The passwords of the parent and the student should not coincide':
		'Паролі батька та учня не повинні збігатися',
	'Your region`s price is set to': 'Ціна вашого регіону встановлена як',
	'and the holder`s reward is': 'а винагорода правоволодільця складає ',
	'regardless of the set price': 'незалежно від встановленої ціни',
	'The given password is not unique for this email':
		'Даний пароль не є унікальним для цього електронної адреси',
	'Enter a valid email address.': 'Введіть дійсну адресу електронної пошти.',
	'The phone number entered is not valid': 'Введений номер телефону недійсний',
	Holiday: 'Свята',
	'Working days': 'Робочі дні',
	Street: 'Вулиця',
	'Location name': 'Назва розташування',
	District: 'Район',
	'Field required': "Поле обов'язкове",
	'Type of legal activity': 'Вид юридичної діяльності',
	'Legal address': 'Юридична адреса',
	'Registration number': 'Реєстраційний номер',
	'Add Group': 'Додати групу',
	'Add Student': 'Додати учня',
	Signin: 'Увійти',
	'Bonus days': 'Бонусні дні',
	'Bonus weeks': 'Бонусні тижні',
	'Are you sure you want to delete?': 'Ви впевнені, що хочете видалити?',
	Delete: 'Видалити',
	Days: 'Днів',
	Confirm: 'Підтвердити',
	Cancel: 'Скасувати',
	Week: 'Тиждень',
	Weeks: 'Тижні',
	'Group age name': 'Назва віку групи',
	'Set bonus days': 'Встановити бонусні дні',
	'Default language': 'Мова за замовчуванням',
	'With english': 'З англійською',
	'Without english': 'Без англійської',
	'Paid status': 'Cтатус оплати',
	'Not paid': 'Не оплачено',
	Turnover: 'Оборот',
	Block: 'Заблокувати',
	Blocked: 'Заблокованих',
	'On holidays': 'На канікулах',
	Language: 'Мова',
	Discounts: 'Знижки',
	Message: 'Повідомлення',
	Subject: 'Тема',
	Homework: 'ДЗ',
	'Homework ': 'Тренування',
	'Homework on': 'Домашнє завдання на',
	'Sum Sub': 'Форсаж',
	'You need to complete the exercises': 'Вам необхідно виконати вправ',
	Homework: 'Домашнi завдання',
	'Invoice for': 'Рахунок на оплату',
	'PJSC CB "PRIVATBANK" in Kyiv': 'ПАТ КБ "ПРИВАТБАНК" м. Київа',
	Account: 'Рахунок',
	Supplier: 'Постачальник',
	Buyer: 'Покупець',
	'Bank code': 'Код банку ',
	'Type phone number or email': 'Введіть номер телефону або електронну адресу',
	'Type password': 'Введіть пароль',
	'Forgot password': 'Забули пароль',
	'Type your email': 'Введіть адресу електронної пошти',
	Send: 'Відправити',
	'Email sent': 'Лист відправлено',
	'If you are signed up for the project you will receive email with the next instructions to get back access your account':
		'Якщо ви підписалися на проект, ви отримаєте електронний лист із наступними вказівками, щоб повернутися до свого акаунту',
	'Back to the sign in': 'Повернутися до входу в систему',
	'Password or login is not correct': 'Пароль або логін не вiрний',
	'Password recovery': 'Відновлення паролю',
	'Type your new password here': 'Введіть свій новий пароль',
	'Set new password': 'Встановити новий пароль',
	'Learn more': 'Дізнатися більше',
	'About Us': 'Про нас',
	Company: 'Компанія',
	Jobs: 'Робота',
	Press: 'Преса',
	'Terms of Use': 'Умови користування',
	'Privacy Policy': 'Політика конфіденційності',
	'Need help?': 'Потрібна допомога?',
	'Contact us': "Зв'яжіться з нами",
	'Become franchise': 'Станьте франчазі',
	'Select language': 'Оберіть мову',
	English: 'Англійська',
	Russian: 'Російська',
	Azerbaijani: 'Азербайджанська',
	Ukrainian: 'Українська',
	Polish: 'Польський',
	'Mental arithmetic is an oral account technique that rapidly develops the intellectual ability and intelligence of a child between 5 and 14 years of age. The training process takes place on special Japanese accountants Abaсus (Soroban). Mental arithmetic trains simultaneously the left and right hemispheres of the brain, improving visual memory, concentration of attention, creative orientation, imaginative thinking of children and their tendency to fast reading.':
		"Ментальна арифметика - це методика усного рахунку яка стрімко розвиває розумові здібності та інтелект дітей віком від 5 до 14 років. Процес навчання проходить на спеціальних японських рахунках Абакус (Соробан). Ментальна арифметика тренує одночасно ліву та праву півкулі мозку, удосконалюючи зорову пам'ять, концентрацію уваги, креативну спрямованість, образне мислення дітей і їх схильність до швидкісного читання.",
	Management: 'Управлiння',
	'Master Franchise': 'Майстер-франчазi',
	Franchise: 'Франчазi',
	Teachers: 'Вчителi',
	Groups: 'Групи',
	Students: 'Учнi',
	Student: 'Учень',
	Parents: 'Батьки',
	Profile: 'Профіль',
	'My profile': 'Мій профіль',
	Finance: 'Фiнанси',
	Reports: 'Звiти',
	Report: 'Звiт',
	Upload: 'Додати',
	List: 'Список',
	Payments: 'Платежi',
	Documents: 'Скан-копii',
	Lessons: 'Уроки',
	Materials: 'Матерiали',
	Shop: 'Магазин',
	Statistics: 'Статистика',
	Settings: 'Налаштування',
	Pages: 'Сторiнки',
	Logout: 'Вийти',
	Dashboard: 'Особистий кабінет',
	'Access denied': 'Доступ заборонено',
	Create: 'Створити',
	Download: 'Завантажити',
	Status: 'Статус',
	'Payment Date': 'Дата оплати',
	'Payment Amount': 'Сума оплати',
	'Start time': 'Час початку занять',
	'Group age': 'Вік групи',
	Junior: 'Молодші',
	Average: 'Середній',
	Class: 'Клас',
	Older: 'Cтарші',
	Region: 'Регіон',
	Group: 'Група',
	Person: 'Особа',
	Finances: 'Фінанси',
	Actions: 'Дії',
	'Choose date': 'Оберiть дату',
	'Send invoice': 'Рахунок-фактура',
	'Download invoice': ' Звіт',
	'Send email': 'Відправити лист',
	'Create Student': 'Створити учня',
	'The beginning of holidays': 'Початок свят',
	'Start of study': 'Початок навчання',
	'Group name': 'Назва групи',
	'Group address': 'Адреса групи',
	'Group teacher': 'Вчитель групи',
	'Group students': 'Учнi групи',
	'Group statistics': 'Статистика групи',
	Tasks: 'Завдання',
	'Only task': 'Завдання',

	'Current task': 'Поточне завдання',
	'Next tasks': 'Наступнi завдання',
	Search: 'Пошук',
	'General information': 'Загальна iнформацiя',
	'Phone number': 'Номер телефону',
	'First name': "Iм'я",
	Surname: 'По-батьковi',
	'Last name': 'Прiзвище',
	'Date of birth': 'Дата народження',
	Password: 'Пароль',
	'Additional information': 'Додаткова iнформацiя',
	'Id code': 'Iд. код',
	Passport: 'Паспорт',
	'With email newsletter': 'З email розсилкою',
	'Without email newsletter': 'Без email розсилки',
	'Financial information': 'Фiнансова iнформацiя',
	Royalty: 'Роялти',
	'PR contribution': 'PR внесок',
	Currency: 'Валюта',
	Comment: 'Коментар',
	Paid: 'Оплачений',
	Invoices: 'Рахунки-фактури',
	Payer: 'Одержувач',
	'Payment order': 'Платіжне доручення',
	Code: 'Код',
	'Bank of the recipient': 'Банк одержувача',
	Acts: 'Акти',
	Scan: 'Скан',
	'Period report': 'Період звiту',
	City: 'Місто',
	'Full name franchise': 'ПІБ франчайзі',
	'Students active': 'Учнi активнi',
	'Сost of education': 'Повна ціна',
	'Turnover franchise': ' Оборот',
	'Discount sum': 'Сума знижки',
	Proprietor: 'Роялтi',
	'Additional products and services': 'Додаткові продукти та послуги',
	'Full name student': "Повне iм'я учня",
	'Period of study': 'Період навчання',
	'Bonus-days': 'Бонусні дні',
	'The beginning of the holidays': 'Початок свят',
	'Amount of days': 'Кількість днів',
	'Total days': 'Всього днів',
	'Language of instruction': 'Мова навчання',
	Teacher: 'Вчитель',
	Discount: 'Знижка',
	Remuneration: 'Винагорода',
	Goods: 'Товари',
	'Date of creation': 'Дата створення',
	'Date of payment': 'Дата оплати',
	'Goods (works, services)': 'Товари (роботи, послуги)',
	Quantity: 'Кількість',
	Units: 'Одиниці',
	Amount: 'Cума',
	Sum: 'Сума',
	Financial: 'Фiнансова',
	Additional: 'Додаткова',
	General: 'Загальна',
	Total: 'Всього',
	Save: 'Зберегти',
	'Including with': 'У тому числі з',
	'Training materials': 'Навчальні матеріали',
	'Learning contract': 'Договір навчання',
	Games: 'Ігри',
	'NUMBER OF 11 TO 120': 'ЧИСЛА ВІД 11 ДО 120',
	Complexity: 'Складнiсть',
	Start: 'Старт',
	'Speedy numbers': 'Форсаж',
	Anzan: 'Анзан',
	'Abacus is random': 'Абакус рандом',
	Multiplication: 'Множення',
	Division: 'Ділення',
	Abacus: 'Рахівниця',
	'Multiplying by 20': 'множення до 20',
	Squared: 'Піднесення до квадрату',
	'Division to 20': 'ДІЛЕННЯ ДО 20',
	Speed: 'Швидкiсть',
	Repeat: 'Кіл-ть виразів',
	'Game type': 'Тип гри',
	'Digit type': 'Тип чисел',
	Digit: 'Число',
	Time: 'Час',
	Second: 'Секунд',
	Level: 'Рівень',
	'Action with numbers': 'К-ть дій',
	'Action with number': 'К-ть дій',
	'Number of expressions': 'К-ть виразів',
	'Number of expression': 'К-ть виразів',
	'Imaginary abacus': 'Уявна рахівниця',
	'Calculation method': 'Спосіб рахунку',
	'Only negative numbers starting with 99,999,9999 etc., depending on the complexity of the expression: -9, -2, -3, -1 ...':
		'Тільки від’ємні числа, починаючи з 99,999,9999 тощо., в залежності від складності Вираз: -9, -2, -3, -1...',
	'Only subtraction': 'Тільки віднімання',
	'Only positive numbers starting with 0. Expression: +1, +4, +6, +9, +5 ...':
		'Тільки додатні числа, починаючи з 0. Вираз: +1, +4, +6, +9, +5 ...',
	'Only add': 'Тільки додавання',
	'Numbers fall randomly, starting with 0. Expression :: +3, -5, -1, +9, -2 ...':
		'Числа випадають випадковим чином, починаючи з 0. Вираз:: +3, -5, -1, +9, -2 ...',
	'Random numbers': 'Випадкові числа',
	'CHOOSE COMPLEXITY:': 'ОБЕРІТЬ СКЛАДНІСТЬ:',
	'AMOUNT OF ACTIONS WITH NUMBER': 'КІЛЬКІСТЬ ДІЙ',
	FAMILY: "СІМ'Я",
	'BIG FRIENDS': 'ВЕЛИКІ ДРУЗІ',
	'LITTLE FRIENDS': 'МАЛЕНЬКІ ДРУЗІ',
	'JUST FRIENDS': 'ПРОСТО ДРУЗІ',
	family: "ciм'я",
	'big friends': 'великi друзi',
	'small friends': 'маленькi друзi',
	elementary: 'просто друзi',
	Sound: 'Звук',
	Loading: 'Завантаження',
	back: 'назад',
	Back: 'Назад',
	Add: 'Додати',
	'Add file': 'Додати файл',
	ANSWER: 'Вiдповiдь',
	'Congratulations! You did it! Now you can go to the following exercises':
		'Вітаємо! Ви це зробили! Зараз ви можете перейти до виконання наступних вправ',
	'RIGHT. ANSWER:': 'ПРАВИЛЬНО. ВІДПОВІДЬ:',
	CORRECT: 'ПРАВИЛЬНО',
	'NOT CORRECT': 'НЕ ПРАВИЛЬНО',
	'Try again': 'cпробувати ще раз',
	expression: 'вираз',
	Lesson: 'Урок',
	Oral: 'Усна лiчба',
	'History statistics': 'Історія статистики',
	Open: 'Вiдкрити',
	'Game statistics per day': 'Статистика гри за день',
	'Total played games': 'Усього зiграних ігр',
	'Total correct answers': 'Усього правильних відповідей',
	'Total played:': 'Усього грав',
	Feedback: "Зворотній зв'язок",
	'Leave a review': 'Залишити відгук',
	'Leave us your feedback or wishes and we will definitely consider them in our work.':
		"Залиште нам свої відгуки чи побажання, і ми обов'язково розглянемо їх у нашій роботі.",
	next: 'наступне',
	Next: 'Наступна',
	Previous: 'Попередня',
	'Payment history': 'Історія платежів',
	'Payment status': 'Статус оплати',
	Pay: 'Оплатити',
	'Getting a discount': 'Отримати знижку',
	Training: 'Тренування',
	'Online abacus': 'Онлайн рахівниця',
	'Base 50/100': 'База 50/100',
	multiply_base: 'База 50/100',
	divided: 'ділене',
	'Do not show this instruction again': 'Не показувати цю інструкцію знову',
	'Instructions for homework': 'Інструкція для домашнього завдання',
	divider: 'дільник',
	'Multiplication table': 'Таблиця множення',
	Restore: 'Відновлення',
	Left: 'Залишилось',
	New: 'Новий',
	'Restore Hierarchy': 'Відновити іерархію',
	total: 'всього',
	active: 'активних',
	blocked: 'заблокованих',
	pageError: {
		'403': 'Доступ заборонений.',
		'404': 'Цієї сторінки не існує. Спробуйте ще раз.',
		'500': 'Сервер не відповідає. Спробуйте ще раз.',
	},
	error: {
		'Account deactivated': 'Ваш аккаунт було деактивовано',
	},
	modalNewVersion: {
		text: 'Ви використовуєте застарілу версію сайту.\nОновлення вже доступне.',
		btn: 'Оновити',
	},
	games: {
		negativeNumbers: "Від'ємні числа",
		pause: 'Пауза',
		resume: 'Продовжити',

		columns: {
			name: 'Стовпці',
			users: 'Кількість гравців',
			user: 'Гравець',
			userNames: 'Імена гравців',
		},
	},
	'Indigo-dollars': 'Індиго-долари',
	Balance: 'Баланс',

	modalIndigoDollars: {
		submit: 'Відправити',
		cancel: 'Скасувати',
		title: 'Індиго-долари',
		balance: 'Поточний баланс',
		amount: 'Кількість',
		reason: 'Коментар',
	},

	modalAddNotification: {
		title: 'Додати повідомлення',
		submit: 'Відправити',
		cancel: 'Скасувати',
		empty: 'Повідомлень немає',
	},

	modalTransactionsHistory: {
		title: 'Історія платежів',
		type: {
			withdraw: 'Списання',
			deposit: 'Поповнення',
		},
		empty: 'Список платежів порожній',
	},

	modalCopyHomework: {
		title: 'Копіювання домашнього завдання',
		label: 'Виберіть дату, на яку потрібно копіювати домашнє завдання',
		submit: 'Копіювати',
		cancel: 'Скасувати',
	},

	reportsPage: {
		history: {
			title: 'Історія змін',
			empty: 'Список порожній',
			table: {
				date: 'Дата зміни',
				field_name: 'Дія',
				old_value: 'Старе значення',
				new_value: 'Нове значення',
				user: 'Змінено у користувача',
			},
		},
	},

	pageShop: {
		title: 'Магазин',
		description:
			'В магазині ви можете придбати різні товари для поліпшення візуального вигляду вашого особистого кабінету.',

		tabs: {
			all: 'Всі товари',
			purchased: 'Придбані',
		},

		item: {
			off_all: 'Ні',

			status: {
				AVAILABLE: 'Доступне',
				DEPRECATED: 'Недоступно',
				COMING_SOON: 'Скоро',
			},
			is_activated: 'Обрано',
			set_active: 'Вибрати',
			unset_active: 'Відключити',
			preview: 'Подивитися',
			is_free: 'Безкоштовно',
			buy: 'Купити',
			bought: 'Придбано',
			purchased: 'Придбано',
		},
		empty: {
			all: 'Немає доступних товарів',
			purchased: 'Немає придбаних товарів',
		},

		toast: {
			error: 'Сталася помилка',
			notEnoughMoney: 'Недостатньо коштів',
			itemBought: 'Поліпшення придбано',
			itemActivated: 'Поліпшення активовано',
			itemDeactivated: 'Поліпшення деактивовано',
		},
		confirmPurchase: {
			title: 'Підтвердження покупки',
			message: 'Ви впевнені, що хочете придбати цей товар?',
			confirm: 'Так, купити',
			cancel: 'Скасувати',
		},
	},

	demo: {
		title: 'Безкоштовний демо урок',
		tutorial: {
			title: 'Інструкція',
			text:
				'Вітаємо тебе ти доєднався до онлайн світу ментальної арифметики Indigo Mental.\nIndigo Mental - це найкраща школа по ментальній арифметиці в світі, багаторічний досвід компанії і успіх багатьох учнів по всьому світу на олімпіадах доводять, що дана методика ефективна та унікальна. Багато батьків давно переконалися в ефектівності методики і радіють успіхам своїх дітей не тільки в арифметиці, а в інших науках, музиці, спорті і відзначають великий скачок в інтелектуальних здібностях своєї дитини.\nМентальна арифметика - це японська методика швидкого усного рахунку, яка стрімко розвиває розумові здібності та інтелект дитини. Процес навчання проходить на спеціальних японських рахівницях Абакус (Соробан). Ментальна арифметика тренує одночасно ліве і праве півкулі мозку, удосконалюючи зорову пам\'ять, концентрацію уваги, креативну спрямованість, образне мислення дітей.\nДавай вже приступимо до вивчення ментальної арифметики, для цього натисни на кнопку "PLAY" на відео нижче, слухай і повторюй.',
		},
	},

	disableStudent: {
		btn: 'Відключити учня',
		list: 'Учні без дати деактивації',
		modal: {
			title: 'Відключення учня',
			description: 'Ви збираєтеся відключити учня',
			fieldLabel: 'Виберіть місяць',
			btnSubmit: 'Відключити',
			btnCancel: 'Скасувати',
		},
	},
}
